module.exports = __webpack_public_path__ + "static/img/tipsBlue.bfb8f627.png";